import {
  MapPermissionsType,
  SeatWithLocationDataType,
} from "@shared/modules/seating/types/seating-types";
import { useState } from "react";
import {
  SeatPermissionSelectProps,
  SelectOptionsType,
} from "./SeatPermissionSelect.props";

export function useSeatPermissionSelect(props: SeatPermissionSelectProps) {
  const { seatArray, updateSeats } = props;
  const [selectedItem, setSelectedItem] = useState<SelectOptionsType>();

  const getTruncatedText = (text: string, length = 20): string => {
    let returnText = text;
    if (text.length > length) {
      returnText = `${text.substring(0, length)}...`;
    }
    return returnText;
  };

  const getSelectOptions = (seat: {
    seatId: number;
    $data?: SeatWithLocationDataType;
    permissions?: Array<MapPermissionsType>;
    selectedPermission?: MapPermissionsType;
  }): Array<SelectOptionsType> => {
    return (
      seat?.permissions?.map((s: MapPermissionsType, index: number) => {
        return {
          id: index,
          name: getTruncatedText(s.seatingItemType?.name ?? ""),
          permission: s,
          seatId: seat.seatId,
        };
      }) ?? []
    );
  };

  const onChangeItem = (selectedItem: SelectOptionsType | null | undefined) => {
    const selectedSeatItem = selectedItem as SelectOptionsType;
    setSelectedItem(selectedSeatItem);
    const updatedSeats = seatArray?.map((s) => {
      if (s.seatId === selectedSeatItem?.seatId) {
        return {
          ...s,
          selectedPermission: selectedSeatItem?.permission,
        };
      }
      return s;
    });
    updateSeats(updatedSeats ?? []);
  };

  return {
    selectedItem,
    getSelectOptions,
    onChangeItem,
  };
}
